import { Filter } from "../filter";

/** Per-entity audit-trail filter — the only required dimensions are the
 *  entity descriptor (name + id). Backend gates with
 *  resourceAccessService.canUserAccessResource on /audit/trail/filter. */
export class AuditTrailFilter extends Filter {
    constructor(
        public entityName: string = "",
        public entityId: string = "",
        value: string = ""
    ) {
        super(value);
    }

    protected override onReset(): void {
        // entity scope is fixed by the row that opened the dialog — never reset
    }
}
